module.exports = __webpack_public_path__ + "img/gw28802.fadde62d.png";